function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { getUserInitials } from "../../../infra/utils";
import { UserRole } from "../../../store/store.model";
import { MenuItem, PopoverOnHover, TextButton, Typography } from 'seagull';
import { InitialsAvatar } from "./InitialsAvatar";
import { routes } from "../../../constants";
import { useHistory } from 'react-router-dom';
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import styles from "./UserMenu.module.scss";
const LogoutIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.60034 23.1001H3.30037C2.66386 23.1001 2.05341 22.8403 1.60333 22.3777C1.15325 21.9151 0.900391 21.2877 0.900391 20.6335V3.36681C0.900391 2.71261 1.15325 2.08521 1.60333 1.62262C2.05341 1.16003 2.66386 0.900146 3.30037 0.900146H9.60034M17.1011 17.9999L23.101 12M23.101 12L17.1011 6M23.101 12L8.7002 12",
  stroke: "#696992",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const Separator = () => /*#__PURE__*/React.createElement("div", {
  className: styles.separator
});
const testPrefix = 'home-sidebar';
export const userMenuRoutes = [{
  id: routes.profile,
  text: 'Profile',
  url: routes.profile,
  shouldShow: true
}, {
  id: routes.anchorBilling,
  text: 'Anchor billing',
  url: routes.anchorBilling,
  shouldShow: _ref => {
    let {
      isVendor,
      role
    } = _ref;
    return isVendor && role !== UserRole.Member;
  }
}, {
  id: routes.importAgreements,
  text: 'Import agreements',
  url: routes.importAgreements,
  shouldShow: _ref2 => {
    let {
      isVendor
    } = _ref2;
    return isVendor;
  }
}];
export default function UserMenu(props) {
  const {
    userInfo
  } = props;
  const userInitials = userInfo && getUserInitials(userInfo);
  const history = useHistory();
  const {
    reset
  } = useStoreActions();
  const topbarLinks = useStore(selectors.filterAvailableRoutes(userMenuRoutes));
  return /*#__PURE__*/React.createElement(PopoverOnHover, {
    placement: "bottom-end",
    openStrategy: "click",
    removePadding: true,
    showArrow: true,
    trigger: triggerProps => /*#__PURE__*/React.createElement("button", _extends({
      "data-testid": "home-sidebar-settings-btn"
    }, triggerProps), /*#__PURE__*/React.createElement(InitialsAvatar, {
      userInitials: userInitials,
      "data-testid": "home-sidebar-avatar",
      isActive: triggerProps['data-popover-is-open'] === 'true'
    })),
    content: _ref3 => {
      let {
        closePopover
      } = _ref3;
      const onClickOption = path => {
        history.push(path);
        closePopover();
      };
      return /*#__PURE__*/React.createElement("div", {
        className: styles.root,
        "data-testid": testPrefix + '-avatar-overflow-menu'
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.avatarContainer
      }, /*#__PURE__*/React.createElement(InitialsAvatar, {
        userInitials: userInitials
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        weight: "normal"
      }, "".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName, " ").concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName)), /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph3",
        skin: "secondary"
      }, userInfo === null || userInfo === void 0 ? void 0 : userInfo.email))), /*#__PURE__*/React.createElement(Separator, null), topbarLinks.map(_ref4 => {
        let {
          text,
          url,
          id
        } = _ref4;
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: id,
          skin: "secondary",
          "data-testid": "".concat(testPrefix, "-").concat(id),
          onClick: () => onClickOption(url)
        }, text);
      }), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(TextButton, {
        className: styles.logout,
        prefixIcon: /*#__PURE__*/React.createElement(LogoutIcon, null),
        underline: "none",
        size: "small",
        skin: "secondary",
        "data-testid": testPrefix + '-logout',
        onClick: () => {
          reset(true);
          history.push(routes.home);
        }
      }, "Log out"));
    }
  });
}